import React from 'react';
import { Text, Button } from 'rebass';
import styled from 'styled-components';
import { signUpComleteContent } from 'modules/SignUp/content';
import ModalContent from '../ModalContent';

interface NotificationModalProps {
  closeModalHandler: VoidFunction;
}

const Content = styled(ModalContent)`
  flex-direction: column;
  padding: 35px;
`;

const SignUpComplete: React.FC<NotificationModalProps> = ({ closeModalHandler }) => {
  return (
    <Content css="max-width: 550px;">
      <Text fontSize={6} fontWeight={6} mb={5}>
        {signUpComleteContent.employer.title}
      </Text>
      <Text fontSize={5} fontWeight={6} textAlign="center" mb={6}>
        {signUpComleteContent.employer.text}
      </Text>
      <Button variant="primary" onClick={closeModalHandler}>
        {signUpComleteContent.employer.button}
      </Button>
    </Content>
  );
};

export default SignUpComplete;
